<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getDetails,
  addFreight,
  getFreight,
  uploadBillFlie,
  exportUpload,
  getExtFiles,
  addExtFiles,
  deleteFile,
  addBranchFreight,
} from "@/api/finance/bill";
import { hangBill, deleteBillDetails } from "@/api/finance/bill_hq";

import { getExpense } from "@/api/finance/expense";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";

export default {
  components: {
    cTable,
  },
  props: {
    row: {
      type: Object,
    },
  },
  data() {
    return {
      config: {
        slot: "div",
        rows: this.row,
      },
      methods: {
        list: (p) => {
          p.id = this.config.rows.financeInfo.id;
          p.from = 'portal'
          return getDetails(p);
        },
        getExpense,
        getExtFiles,
        hangBill,
        exportUpload,
        uploadBillFlie,
        deleteBillDetails,
        deleteFile,
        addExtFiles,
        addFreight,
        getFreight,
        getCountry,
        addBranchFreight,
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          // this.totalAmount.push(
          //   {
          //     text: this.$t("total"),
          //     replace_currency: "CNY",
          //     total_amount: data.total_cny,
          //   },
          //   {
          //     text: this.$t("total"),
          //     replace_currency: "USD",
          //     total_amount: data.total_usd,
          //   }
          // );
        },
      },
      totalAmount: [],
      modals: {
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map((item) => item.id);
              data.id = this.$page.config.rows.id;
              this.$page.handleRequestMethods("hangBill", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 80,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        uploadFiles: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.id = this.$page.config.rows.financeInfo.id;
              this.$page
                .handleRequestMethods("addExtFiles", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            modalContentBind: {
              style: {
                height: "600px",
              },
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ files: 23 }, { deductible_fee: 23 }, { other_charges: 23 }],
          fields: [
            {
              name: this.$t("updateFile") + this.$t("files"),
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx,.xls",
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file);
                  formData.append("batchNo", new Date().getTime());
                  uploadBillFlie(this.config.rows.id, formData).then((res) => {
                    this.$Message[res.data.status ? "success" : "error"]({
                      background: true,
                      content: res.data.msg,
                    });
                    if (res.data.status) {
                      this.$refs["table"]
                        .getModal("uploadFiles")
                        .list.push(res.data.payload);
                    }
                  });
                  return false;
                },
              },
            },
            {
              name: () => this.$t("deductExpenses"),
              key: "deductible_fee",
              component: "InputNumber",
              bind: {
                step: 0.01,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("receivable") + this.$t("otherCost"),
              key: "other_charges",
              component: "InputNumber",
              bind: {
                step: 0.01,
                min: 0,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                name: () => this.$t("fileName"),
                key: "file_name",
                align: "left",
                minWidth: 170,
              },
              {
                name: () => this.$t("operation"),
                type: "btns",
                width: 80,
                list: [
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    bind: {
                      icon: "md-trash",
                    },
                  },
                ],
                methods: {
                  delete({ row }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.handleRequestMethods("deleteFile", row.id).then(
                          (res) => {
                            this.$Message["success"]({
                              background: true,
                              content: res.msg,
                            });
                            this.handleRequestMethods(
                              "getExtFiles",
                              this.config.rows.id
                            ).then((res) => {
                              this.getModal("uploadFiles").open(
                                res,
                                function () {
                                  this.list = res.payload.files;
                                }
                              );
                            });
                          }
                        );
                      },
                    });
                  },
                },
              },
            ],
          },
        },
        freightAppend: {
          // contentSlot: "freight",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              if (this.type == "addBranchFreight") {
                data["otherItem"] = JSON.parse(JSON.stringify(this.list));
              } else data["data"] = JSON.parse(JSON.stringify(this.list));
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true,
              sticky: true,
            },
          },
          footer: {
            show: () => true,
          },
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "warning",
                    },
                    icon: "md-add",
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    icon: "md-trash",
                    disabled({ row }) {
                      return this.list.length == 1 || row.allow_del == 0;
                    },
                  },
                ],
                methods: {
                  add() {
                    this.getModal("freightAppend").list.unshift({
                      expense_item_id: "",
                      expense_item_name: "",
                      amount_cny: 0,
                      amount_usd: 0,
                      allow_edit: 1,
                      allow_del: 1,
                    });
                  },
                  delete({ rowIndex }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.getModal("freightAppend").list.splice(rowIndex, 1);
                      },
                    });
                  },
                },
              },
              {
                name: () => this.$t("expense"),
                align: "left",
                key: "expense_item_id",
                placeholder() {
                  return this.$t("select") + this.$t("expense");
                },
                component: "Select",
                bind: {
                  style: "width:100%",
                  type: "number",
                },
                config: {
                  label({ row }) {
                    return row.name + (row.pin ? "(" + row.pin + ")" : "");
                  },
                  value: "id",
                },
                disabled({ row }) {
                  return (
                    this.$page.config.rows.financeInfo.status !=
                      "WAIT_CONFIRM" || row.allow_del == 0
                  );
                },
                methods: {
                  async list({ field }) {
                    field.options = (await getExpense()).data.payload.rows;
                    this.$forceUpdate();
                  },
                  click({ row, rowIndex }) {
                    this.list[rowIndex].expense_item_name = row.name;
                    this.$forceUpdate();
                  },
                },
              },
              {
                name: () => this.$t("reChAmount") + "(CNY)",
                align: "left",
                key: "amount_cny",
                component: "InputNumber",
                disabled({ row }) {
                  return (
                    this.$page.config.rows.financeInfo.status !=
                      "WAIT_CONFIRM" ||
                    row.allow_del == 0 ||
                    row.amount_usd != 0
                  );
                },
                bind: {
                  min: 0,
                  style: "width:100%",
                },
              },
              {
                name: () => this.$t("reChAmount") + "(USD)",
                align: "center",
                key: "amount_usd",
                component: "InputNumber",
                disabled({ row }) {
                  return (
                    this.$page.config.rows.financeInfo.status !=
                      "WAIT_CONFIRM" ||
                    row.allow_del == 0 ||
                    row.amount_cny != 0
                  );
                },
                bind: {
                  min: 0,
                  style: "width:100%",
                },
              },
            ],
          },
        },
      },
      // footer: {
      //   show: () => true,
      //   render: (h) => {
      //     return h(
      //       "div",
      //       {
      //         class: "footer-content",
      //       },
      //       this.totalAmount.map((item) => {
      //         return h(
      //           "div",
      //           {
      //             class: "footer-content-item",
      //           },
      //           [
      //             h("span", { class: "span-head" }, item.text),
      //             h(
      //               "span",
      //               { class: "span-head" },
      //               item.replace_currency + ":"
      //             ),
      //             h(
      //               "span",
      //               {
      //                 class: "span-title",
      //               },
      //               parseFloat(item.total_amount)
      //             ),
      //           ]
      //         );
      //       })
      //     );
      //   },
      // },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("countryName");
            },
            component: "Select",
            options: [],
            config: { label: "code", value: "code" },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: this.$t("updateFile") + this.$t("Appendix"),
              type: "handUpload",
              fnName: "handUpload",
              bind: {
                icon: "ios-cloud-upload-outline",
                type: "warning",
              },
            },
            {
              name: this.$t("setting") + this.$t("freight_append"),
              type: "setting",
              fnName: "setting",
              bind: {
                type: "error",
              },
              disabled() {
                return (
                  !this.selectAll.length ||
                  this.config.rows.financeInfo.status != "WAIT_CONFIRM"
                );
              },
              id: 661,
            },
            {
              name: this.$t("hang"),
              type: "hang",
              fnName: "hang",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return (
                  !this.selectAll.length ||
                  this.config.rows.financeInfo.status != "WAIT_CONFIRM"
                );
              },
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                icon: "md-trash",
                type: "error",
              },
              disabled() {
                return (
                  !this.selectAll.length ||
                  this.config.rows.financeInfo.status != "WAIT_CONFIRM"
                );
              },
            },
          ],
          methods: {
            setting() {
              let data = {
                id: this.config.rows.id,
                airway_number: this.selectAll.map(
                  (item) => item.airway_bill_number
                ),
              };
              this.getModal("freightAppend").open(data, function () {
                this.list = [
                  {
                    expense_item_id: "",
                    expense_item_name: "",
                    amount_cny: 0,
                    amount_usd: 0,
                  },
                ];
                this.setTitle(this.$t("freight_append"));
                this.type = "addBranchFreight";
              });
            },
            export() {
              this.handleRequestMethods(
                "exportUpload",
                this.config.rows.financeInfo.id
              ).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                window.open(this.$globalUrl + res.payload.path);
              });
            },
            handUpload() {
              this.handleRequestMethods(
                "getExtFiles",
                this.config.rows.financeInfo.id
              ).then((res) => {
                this.getModal("uploadFiles").open(res.payload, function () {
                  this.list = res.payload.files;
                  this.setTitle(this.$t("updateFile") + this.$t("files"));
                });
              });
            },
            hang() {
              this.getModal("hang").open({}, function () {
                this.setTitle(this.$t("hang"));
              });
            },
            delete() {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    id: this.config.rows.id,
                    ids: this.selectAll.map((item) => {
                      return item.id;
                    }),
                  };
                  this.handleRequestMethods("deleteBillDetails", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          fixed: "left",
          width: 60,
        },
        {
          name: () => this.$t("inboundTime"),
          key: "inbound_time",
          width: 130,
        },
        {
          name: () => this.$t("outbound_time"),
          key: "outbound_time",
          width: 130,
        },
        {
          name: () => this.$t("clientName"),
          key: "clientInfo.account",
          width: 95,
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "left",
          minWidth: 160,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 130,
          fixed: "left",
        },
        {
          name: () => this.$tz("国家"),
          key: "country_code",
          minWidth: 110,
        },
        {
          name: () => this.$t("channel_code"),
          key: "shipment.transport_mode",
          width: 95,
        },
        {
          name: () => this.$tz("体积重量"),
          key: "charge_volume",
          width: 95,
        },
        {
          name: () => this.$t("计费重"),
          key: "charge_params",
          width: 95,
        },
        {
          name: () => this.$t("货物价值"),
          key: "values",
          width: 110,
        },
        {
          name: "COD",
          children: [
            {
              name: this.$tz("COD,类型"),
              key: "cod_type",
              width: 110,
            },
            {
              name: this.$t("cod_amount1"),
              key: "cod_amount",
              width: 110,
            },
            {
              name: this.$t("cod_currency"),
              key: "replace_currency",
              width: 110,
            },
          ],
        },
        {
          name: this.$tz("费用"),
          children: [
            {
              key: "chargeInfo.freight_fees",
              name: this.$t("receivable") + this.$t("freight_fees"),
              width: 110,
            },
            {
              key: "chargeInfo.actual_freight",
              name: this.$t("actual_receipt") + this.$t("freight_fees"),
              width: 110,
            },
            {
              key: "chargeInfo.qou_op_fees",
              name: this.$t("extra_charge"),
              width: 110,
            },
            {
              key: "chargeInfo.remote_regions_fee",
              name: this.$t("remote_fee"),
              width: 110,
            },
            {
              key: "chargeInfo.peak_season_fee",
              name: this.$t("epidemic") + this.$t("freight_append"),
              width: 110,
            },
            {
              key: "chargeInfo.other_fee",
              name: this.$t("otherCost"),
              width: 110,
            },
            {
              key: "chargeInfo.sub_total",
              name: this.$t("receivable") + this.$t("subtotal"),
              width: 110,
            },
            {
              key: "chargeInfo.total_tax",
              name: this.$t("total_tax"),
              width: 110,
            },
          ],
        },

        {
          name: this.$t("to") + this.$t("rate"),
          children: ["freight_unit", "cny", "usd", "kwd", "sar", "aed"].map(
            (t, i) => {
              return {
                name: i === 0 ? this.$t("toCurrency") : t.toLocaleUpperCase(),
                key: "rateInfo." + (t + (i === 0 ? "" : "_to_rate")),
                width: 110,
              };
            }
          ),
        },
        {
          name: this.$t("receivableTotal"),
          key: "total_amount",
          width: 100,
          fixed: "right",
          methods: {
            render({ row }) {
              return row.total_amount + " " + row.rateInfo.freight_unit;
            },
          },
        },
      ],
    };
  },
  async mounted() {
    let data = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    this.header.searchs.forEach((item) => {
      if (item.key === "to_country") item.options = data;
    });
  },
};
</script>
